export default "__VITE_ASSET__0Fogzy1s__"